const initState = () => ({
  customerContactPersons: [],
})

export const state = initState

export const mutations = {
  setCustomerContactPersons(state, {contactPersons}) {
    state.customerContactPersons = contactPersons
  },
}

export const actions = {
  async getCustomerContactPersons({commit}, customerId = undefined) {
    const contactPersons = await this.$axios.$get(
      '/customers/getContactPersons' +
        (customerId ? `?customerId=${customerId}` : '')
    )
    commit('setCustomerContactPersons', {contactPersons})
  },
  async getCustomerContactPersonsInformation({commit}, customerId = undefined) {
    const contactPersons = await this.$axios.$get(
      '/customers/getContactPersonsInformation' +
      (customerId ? `?customerId=${customerId}` : '')
    )
    return contactPersons;
  },
  async createContactPerson({ commit, state }, payload) {
    try {
      const newPerson = await this.$axios.$post('/User/createContactPerson', payload);

      if (newPerson) {
        const updatedList = [...state.customerContactPersons, newPerson];
        commit('setCustomerContactPersons', { contactPersons: updatedList });
      }
      return newPerson;
    } catch (e) {
      console.error(e);
      return null;
    }
  },
  async deleteContactPerson({ commit }, customer) {
    try {
      const contactPersonId = customer.id || customer.ID;
      const response = await this.$axios.$delete(`/User/contactperson/${contactPersonId}`);

      if (response && !response.hasErrors) {
        this.$toast.success("Member removed");
        return true;
      }

      if (response && response.errorMessages?.length > 0) {
        this.$toast.error(response.errorMessages[0].value);
      }
      return false;
    } catch (e) {
      this.$toast.error("Error while deleting member");
      return false;
    }
  },
}
